import React from 'react';
import Checkbox from '../checkbox/Checkbox';
import './listaCheck.css';

const listaCheck = ({ checkboxList, checkboxFunction, enable, alineacion }) => {
  if (checkboxList === null) {
    return null;
  }
  return (
    <div className="row listaCheck">
      {
        checkboxList && checkboxList.map((valor) => {
          return (
            <div className={alineacion === "vertical" ? "col-12" :"col"} key={valor.key}>
              <Checkbox
                checkboxValue={valor.value}
                checkboxName={valor.name}
                checkboxStatus={valor.isChecked}
                checkboxFunction={checkboxFunction}
                checkboxEnable={valor.enable ? valor.enable:!enable}
                tooltip={valor.tooltip}
                tooltipTag={valor.tooltipTag}
              />
            </div>
          )
        })
      }
    </div>
  );
};

export default listaCheck;